import React from 'react';
import getSeoData, { addJavaHeaders } from '../../utils';
import DosierDetail from './DosierDetail';
import Layout from '../../components/Layout';
import NotFound from '../not-found/NotFound';
import { setCity } from '../../actions/city';
import { checkStatus, getCityConfig, parseJSON } from '../../apiUtils';
import { startFetchingDosierData, setDosierData, fetchingDosierDataError } from '../../actions/dosierDetail';

async function action({ fetch, params, store }) {
	const {
		token: { token },
		cityConfig,
		dosierDetail,
	} = store.getState();

	const city = setCity({
		store,
		params,
		fetch,
	});

	if (!cityConfig) {
		await getCityConfig(city.cityIds, {
			store,
			fetch,
		});
	}

	const seoTitle = 'zastroischiki';
	const { title, description, keywords } = await getSeoData(fetch, seoTitle, params.name, city.cityIds);

	const { dosierData: storedDosierData, loading } = dosierDetail;

	if (!loading && (!storedDosierData || storedDosierData.slug !== params.name)) {
		store.dispatch(startFetchingDosierData());
		const dosierURL = '/lexsApi/developer/card';
		const fetchOptions = {
			method: 'POST',
			...addJavaHeaders(token),
			body: JSON.stringify({
				slug: params.name,
			}),
		};

		try {
			await fetch(dosierURL, fetchOptions)
				.then(checkStatus)
				.then(parseJSON)
				.then((results) => {
					store.dispatch(setDosierData(results.data));
				});
		} catch (e) {
			store.dispatch(fetchingDosierDataError());
			return {
				chunks: ['not-found'],
				title: 'Страница не найдена',
				component: (
					<Layout isNotFound>
						<NotFound title={title} />
					</Layout>
				),
				status: 404,
			};
		}
	}

	return {
		chunks: ['dosierDetail'],
		title,
		description,
		keywords,
		component: (
			<Layout route="dosier-detail">
				<DosierDetail />
			</Layout>
		),
	};
}

export default action;
